
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Create root and render app with StrictMode disabled to avoid duplicate effects and renders
createRoot(document.getElementById("root")!).render(<App />);
